import React from "react";
import { CheckCircle } from "lucide-react";
import "./B2BSuccessMessage.css";

interface B2BSuccessMessageProps {
  title: string;
  message: string;
  additionalInfo?: string;
  className?: string;
  iconClassName?: string;
  children?: React.ReactNode;
}

/**
 * Reusable success message component for B2B flows
 * Replaces repeated success message patterns across auth components
 */
const B2BSuccessMessage: React.FC<B2BSuccessMessageProps> = ({
  title,
  message,
  additionalInfo,
  className = "",
  iconClassName = "b2b-success-icon",
  children,
}) => {
  return (
    <div className={`b2b-success-message ${className}`}>
      <CheckCircle className={iconClassName} />
      <h1>{title}</h1>
      <p>{message}</p>
      {additionalInfo && (
        <p className="b2b-additional-info">{additionalInfo}</p>
      )}
      {children}
    </div>
  );
};

export default B2BSuccessMessage;

